﻿import * as resize from './resizeObserver';

export { resize };